// extracted by mini-css-extract-plugin
export default {"shopCardContainer":"ShopCard_shopCardContainer__qjWW9","left":"ShopCard_left__kgn6k","right":"ShopCard_right__cN8Db","content":"ShopCard_content__+PNaS"};